<template>
    <vx-alert color="danger" :closeable="false" data-test="quick-blast-group-status-alert">
        <template v-slot:icon>
            <font-awesome-icon :icon="faHexagonExclamation" widthAuto></font-awesome-icon>
        </template>

        {{ message }}
    </vx-alert>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { VxAlert } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons';
import { GROUP_STATUS_CLOSED, GROUP_STATUS_DRAFT, GROUP_STATUS_SUSPENDED } from '~/constants/groupStatuses';

const props = defineProps<{
    status?: string;
}>();

const message = computed(() => {
    switch (props.status) {
        case GROUP_STATUS_DRAFT:
            return 'This group is in Draft. Quick Blasts can be created and sent once the group is Active. Use Message Hub for test sends in the meantime.';
        case GROUP_STATUS_SUSPENDED:
            return "This group is Suspended. Quick Blasts can't be created or sent until the group is Active again.";
        case GROUP_STATUS_CLOSED:
            return "This group is Closed. Quick Blasts can't be created or sent.";
        default:
            return 'Quick Blasts can only be created and sent when the group is Active.';
    }
});
</script>
